export default "__VITE_ASSET__HruLj1Ya__"